import { isExactMatch } from '../shared.js';

const areSameNonPrescriptionBundleLineItem = (serverLineItem, draftLineItem)=>{
    var ref;
    if (serverLineItem.__typename !== 'LineItemBundle') {
        return false;
    }
    if (((ref = serverLineItem.typeDetails) === null || ref === void 0 ? void 0 : ref.__typename) !== 'BundleNonPrescriptionBundleTypeDetails') {
        return false;
    }
    const serverSkus = new Set(serverLineItem.bundleLineItems.map((bl)=>bl.legacyProduct.sku
    ));
    const draftSkus = new Set([
        draftLineItem.sku,
        ...draftLineItem.bundleLineItems.map((b)=>b.sku
        )
    ]);
    return isExactMatch(serverSkus, draftSkus);
};

export { areSameNonPrescriptionBundleLineItem };
//# sourceMappingURL=are-same-non-prescription-bundle.js.map
